import { httpGet } from '@/services/http';
import { transformDonor, BackendDonor, FrontendDonor } from '@/services/transform';

/** GET /api/public/donors - 获取公开捐赠人列表 */
export async function getPublicDonors(): Promise<FrontendDonor[]> {
  try {
    const data = await httpGet<BackendDonor[]>('/public/donors');
    return data.map(transformDonor);
  } catch (error) {
    console.error('获取公开捐赠人列表失败:', error);
    return [];
  }
}

/** GET /api/public/donors/:id - 获取捐赠人详情 */
export async function getPublicDonorById(id: string): Promise<FrontendDonor | null> {
  try {
    const data = await httpGet<BackendDonor>(`/public/donors/${id}`);
    return transformDonor(data);
  } catch (error) {
    console.error('获取捐赠人详情失败:', error);
    return null;
  }
}
